import { defaultStatus } from '@/_schemas/status-input';
import type { RouteListItem } from '@/types';

import { type OrganizationTypeFormSchema } from './schemas';

import { settingsBcLink } from '../../model';

export const defaultValues: Readonly<OrganizationTypeFormSchema> = {
  id: -1,
  name: '',
  plural: '',
  status: defaultStatus,
} as const;

export const breadcrumbsLinks: RouteListItem[] = [
  settingsBcLink,
  { path: '/settings/organization-types', name: 'Organization Types' },
];
